import { render, staticRenderFns } from "./construccion.vue?vue&type=template&id=553957d1"
import script from "./construccion.vue?vue&type=script&lang=js"
export * from "./construccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports